module.exports = __webpack_public_path__ + "static/media/icon-double-fill.3f8316a9.svg";